
























import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
import notificationService from '@/services/notificationService';
import cPopup from '@/components/default/Popup.vue';
import {
  DxForm,
  DxSimpleItem,
  DxRequiredRule,
  DxGroupItem,
  DxLabel,
} from 'devextreme-vue/form';

import contactsRepository from '@/services/contactsRepository';

@Component({
  components: {
    cPopup,
    DxForm,
    DxSimpleItem,
    DxRequiredRule,
    DxGroupItem,
    DxLabel,
  },
})
export default class AddArticleToOrderPopup extends Vue {
    @Prop({required: true})
    private projectId!: string;

    @Prop({required: true})
    private supplierId!: string;

    private show: boolean = false;
    private saving: boolean = false;

    private model: any = {
        selectedArticleId: '',
        quantity: 0,
    };

    public Open() {
        this.show = true;
    }

    private async save() {
        try {
            const validationResult = (this.$refs.AddArticleToOrderPopupForm as any).instance.validate();
            if (validationResult.isValid) {
                this.saving = true;

                const price = (await contactsRepository
                    .getLabourAgreementsPrice(this.supplierId, this.model.selectedArticleId, this.projectId)).data;

                const article = this.articles.find((o) => o.id === this.model.selectedArticleId);
                const line: IOrderLine = {
                    quantity: this.model.quantity,
                    measuringUnit: article ? article.measuringUnit : '',
                    unitPrice: price,
                    totalPrice: price * this.model.quantity,
                    description: article ? `${article.name}: ${article.description}` : '',
                    remarks: '',
                    delivered: false,
                    metaData: {
                        articleId: article ? article.id : '',
                    },
                };

                this.$emit('add', line);
                this.show = false;
            } else {
                notificationService.invalidForm();
            }
        } catch (err) {
            notificationService.showAxiosError(err);
        } finally {
            this.saving = false;
        }
    }

    get articles() {
        return this.$store.getters['articles/items'] as IArticle[];
    }

    get articlesOptions() {
        const self = this;
        return {
        dataSource: this.articles,
        valueExpr: 'id',
        displayExpr: 'name',
        searchExpr: 'name',
        searchEnabled: true,
        showClearButton: true,
        };
    }

    get fields() {
        return [
            {
                itemType: 'simple',
                dataField: 'selectedArticleId',
                editorOptions: this.articlesOptions,
                editorType: 'dxSelectBox',
                label: {
                    text: 'Code',
                },
                validationRules: [
                    { type: 'required', message: 'Veld is verplicht' },
                ],
            },
            {
                itemType: 'simple',
                dataField: 'quantity',
                editorType: 'dxNumberBox',
                label: {
                    text: 'Aantal',
                },
            },
        ];
    }
}
